import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for the Unit Table Page (/unit)
 */
export const unitTableTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_UnitTable_Welcome_Title"),
    description: t("Tour_UnitTable_Welcome_Description"),
    target: () => queryTourTarget("unit-table-section"),
    placement: "bottom",
  },
  {
    title: t("Tour_UnitTable_Status_Title"),
    description: t("Tour_UnitTable_Status_Description"),
    target: () => queryTourTarget("unit-status-filter"),
    placement: "bottom",
  },
  {
    title: t("Tour_UnitTable_Filters_Title"),
    description: t("Tour_UnitTable_Filters_Description"),
    target: () => queryTourTarget("unit-other-filters"),
    placement: "bottom",
  },
  {
    title: t("Tour_UnitTable_Add_Title"),
    description: t("Tour_UnitTable_Add_Description"),
    target: () => queryTourTarget("unit-add-button"),
    placement: "left",
  },
];
